import Vue from "vue";
import { declineOfNumber, formatPrice } from "@/utils";

Vue.filter("formatCase", (value, titles) => declineOfNumber(value, titles));
Vue.filter("formatPrice", (value) => formatPrice(value));
